import { useEffect, useRef } from 'react'

function useMultiClick(count: number, resetTime: number, callback: () => void) {
  const clickTimesRef = useRef(0)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  const registerClick = () => {
    clickTimesRef.current += 1

    if (clickTimesRef.current >= count) {
      callback()
      clearTimer()
      clickTimesRef.current = 0
      return
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => {
      clickTimesRef.current = 0
    }, resetTime)
  }

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }

  useEffect(() => {
    return () => clearTimer()
  }, [])

  return registerClick
}

export default useMultiClick
